import { render } from "./Score.vue?vue&type=template&id=1e179824&scoped=true"
import script from "./Score.vue?vue&type=script&lang=js"
export * from "./Score.vue?vue&type=script&lang=js"

import "./Score.vue?vue&type=style&index=0&id=1e179824&scoped=scoped&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e179824"]])

export default __exports__